// @ts-ignore — formiojs v4 ships without first-class TS types
import { Components } from 'formiojs';
import PdfViewerComp from './PdfViewer/PdfViewerComp.tsx';
import TakePictureComp from './TakePicture/TakePictureComp.tsx';
import VideoPlayerComp from './VideoPlayer/VideoPlayerComp.tsx';

let registered = false;

export const registerCustomComponents = () => {
    if (registered) return;
    registered = true;
    Components.setComponent('pdfviewer', PdfViewerComp);
    Components.setComponent('takepicture', TakePictureComp);
    Components.setComponent('videoplayer', VideoPlayerComp);
};
